import { ID } from '@griply/types';

import {
  FirestoreInstance,
  OrderByDirection,
  WhereFilterOp,
} from '../types/firestore';
import { FirestoreCollections } from '../types/firestore-collections';

export type GetVisionsQueryOptions<
  TCollection = unknown,
  TQuery = unknown,
  TConstraint = unknown,
  TDb = FirestoreInstance,
> = {
  db: TDb;
  collection: (
    db: NoInfer<TDb>,
    path: string,
    ...rest: string[]
  ) => TCollection;
  query: (ref: TCollection, ...constraints: TConstraint[]) => TQuery;
  where: (field: string, op: WhereFilterOp, value: unknown) => TConstraint;
  orderBy: (field: string, direction?: OrderByDirection) => TConstraint;
  limit?: (count: number) => TConstraint;

  userId: ID;
  lifeAreaIds?: ID[];
  maxResults?: number;
};

export const getVisionsQuery = <
  TCollection,
  TQuery,
  TConstraint,
  TDb = FirestoreInstance,
>(
  options: GetVisionsQueryOptions<TCollection, TQuery, TConstraint, TDb>,
): TQuery => {
  const {
    db,
    collection,
    query,
    where,
    orderBy,
    limit,
    userId,
    lifeAreaIds,
    maxResults,
  } = options;

  const constraints: TConstraint[] = [
    where('roles.all', 'array-contains', userId),
  ];

  if (lifeAreaIds?.length) {
    constraints.push(where('lifeAreaId', 'in', lifeAreaIds));
  }

  constraints.push(orderBy('createdAt', 'desc'));

  if (maxResults && limit) {
    constraints.push(limit(maxResults));
  }

  return query(collection(db, FirestoreCollections.Visions), ...constraints);
};
